import { fetchAuthSession } from 'aws-amplify/auth';
import { ApolloClient as ApolloClientBase, ApolloLink, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { cache, setupCachePersistor } from './cache';

export type ApolloClient = ApolloClientBase<object>;

// Custom auth link that adds the Cognito JWT token to requests
const createCognitoAuthLink = () =>
    setContext(async (_, { headers }) => {
        try {
            const session = await fetchAuthSession();
            const token = session.tokens?.idToken?.toString() ?? '';
            return {
                headers: {
                    ...headers,
                    authorization: token,
                },
            };
        } catch (error) {
            return { headers };
        }
    });

export const buildApolloClientAndRestoreCache = async (url: string, _region: string): Promise<ApolloClient> => {
    const httpLink = createHttpLink({ uri: url });
    const authLink = createCognitoAuthLink();
    const link = ApolloLink.from([authLink, httpLink]); // For debugging: ApolloLink.from([logLink, authLink, httpLink]);
    const client: unknown = new ApolloClientBase({
        cache,
        link,
    });
    const typedClient = client as ApolloClient;
    await setupCachePersistor();
    return typedClient;
};

export const logLink = new ApolloLink((operation, forward) => {
    return forward(operation).map((result) => {
        console.log('GraphQL operation:', operation.operationName, operation.variables);
        return result;
    });
});
